import { createContext } from "react";

// Lightweight context so the sidebar's search input can drive
// MainListItems filtering without prop-drilling through every
// menu group. Default empty string means "show everything".
export const SidebarSearchContext = createContext("");
